<script>
  import Breadcrumbs from "@/core/components/Breadcrumbs"
  import TariffCoefficientList from "./partials/TariffCoefficientList.vue"
  import Modal from "@/core/components/NewModal.vue"
  import SearchSelect from "@/core/components/SearchSelect"
  import Icon from "@/core/components/Icon"
  import { lowerCase } from "lodash"
  import Datepicker from "vuejs-datepicker"
  import { ptBR } from "vuejs-datepicker/dist/locale"

  export default {
    components: {
      Breadcrumbs,
      TariffCoefficientList,
      SearchSelect,
      Modal,
      Icon,
      Datepicker,
    },
    data() {
      return {
        locale: ptBR,
        crumbs: [
          { name: "Início", path: "index" },
          { name: "Linhas", path: "lines.index" },
          {
            name: "Coeficiente Tarifário",
            path: "lines.tariffCoefficient",
          },
        ],
        options: [
          { id: 0, name: "Opção 1" },
          { id: 1, name: "Opção 2" },
          { id: 2, name: "Opção 3" },
          { id: 3, name: "Opção 4" },
          { id: 4, name: "Opção 5" },
        ],
        transportadorasFilter: { id: 0, name: "Transportadora" },
        agendamentoFilter: { id: 0, name: "Agendamento" },
        situacaoFilter: { id: 0, name: "Situação" },
        dtiniciovalidade: "",
        dtfimvalidade: "",
        filters: {
          nutransportadora: "",
          dtiniciovalidade: "",
          dtfimvalidade: "",
          flsituacao: "",
        },
      }
    },
    methods: {
      cleanFilters() {
        this.transportadorasFilter = { id: 0, name: "Transportadora" }
        this.linhasFilter = { id: 0, name: "Linha" }
        this.agendamentoFilter = { id: 0, name: "Agendamento" }
        this.situacaoFilter = { id: 0, name: "Situação" }
        this.filters = {
          nutransportadora: "",
          dtiniciovalidade: "",
          dtfimvalidade: "",
          flsituacao: "",
        }
        this.$refs.dtiniciopicker.clearDate()
        this.$refs.dtfimpicker.clearDate()
      },
      showModal() {
        this.$refs.modalCoefficient.show()
      },
      createTariffCoefficient(tariffType) {
        this.$router.push({
          name: "lines.tariffCoefficient.create",
          params: { tariffType: tariffType },
        })
      },
      searchTariffCoefficients() {
        this.$refs.table.searchTariffCoefficients()
      },
      changeTransportadorasFilter(transportadora) {
        this.transportadorasFilter = transportadora
        this.filters.nutransportadora = this.transportadorasFilter.id
      },
      changeDtiniciovalidade(date) {
        this.dtiniciovalidade = date
        this.filters.dtiniciovalidade = date
      },
      changeDtfimvalidade(date) {
        this.dtfimvalidade = date
        this.filters.dtfimvalidade = date
      },
      capitalize(string) {
        let arrayPalavras = string.split(" ")
        let arrayPalavrasCapitalized = arrayPalavras.map((palavra) => {
          return palavra.charAt(0).toUpperCase() + lowerCase(palavra.slice(1))
        })
        return arrayPalavrasCapitalized.join(" ")
      },
    },
  }
</script>
<style>
  button:focus {
    outline: 0 !important;
  }
  .non-selected-button {
    opacity: 0.5;
    background-image: linear-gradient(to right, #b4e5c7, #38c172);
  }
  .non-selected-button:hover {
    color: white;
    background-image: linear-gradient(to right, #38c172, #029e4d);
    opacity: 1;
  }
</style>

<template>
  <div class="w-full bg-gray-light">
    <portal-target name="modals"/>
    <div class="px-2 my-4 sm:px-6">
      <Breadcrumbs class="mb-2" :crumbs="crumbs"/>
      <div
        class="flex flex-wrap justify-between align-baseline border-b-2 border-green-base mb-2"
      >
        <h1 class="text-green-base uppercase pt-5">Coeficiente Tarifário</h1>
        <router-link
          tag="button"
          class="px-2 py-2 mb-2 form-new-green sm:py-1"
          :to="{ name: 'lines.tariffCoefficient.create' }"
        >
          <div class="flex items-center justify-center">
            <Icon icon="plus" class="h-4 mr-1 fill-current"/>
            Novo Coeficiente
          </div>
        </router-link>
      </div>
      <form class="p-2" @submit.prevent="searchTariffCoefficients">
        <h1 class="text-green-base mb-2">Filtre sua pesquisa</h1>
        <div class="grid sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-5">
          <div
            class="grid sm:col-span-5 md:col-span-5 lg:col-span-4 lg:grid-cols-4 lg:w-11/12 gap-4"
          >
            <SearchSelect
              :selected.sync="transportadorasFilter"
              :search-keys="[]"
              :search-remote="true"
              :lazy-load="true"
              options-url="/api/registry/organizations/"
              :digits-before-search="3"
              option-key="transportadora"
              optional-placeholder-icon="icon_bus.svg"
              optional-carret-icon="icon_caret.svg"
              field-class="py-2"
              name="organization"
              :option-value="
                                transportadora =>
                                    capitalize(transportadora.name)
                            "
              @changed="changeTransportadorasFilter"
            ></SearchSelect>
            <Datepicker
              v-model="dtiniciovalidade"
              format="dd/MM/yyyy"
              :language="locale"
              :full-month-name="true"
              input-class="form-input mb-0 h-8"
              placeholder="Início da Vigência"
              @input="changeDtiniciovalidade"
              ref="dtiniciopicker"
            />
            <Datepicker
              v-model="dtfimvalidade"
              format="dd/MM/yyyy"
              :language="locale"
              :full-month-name="true"
              input-class="form-input mb-0 h-8"
              placeholder="Fim da Vigência"
              @input="changeDtfimvalidade"
              ref="dtfimpicker"
            />
          </div>
          <div
            class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 sm:w-full justify-end lg:mr-3 pt-2 lg:pt-0 gap-2 lg:gap-0"
          >
            <button
              class="flex sm:col-span-1 md:col-span-1 lg:col-span-1 justify-center items-center form-red text-xs uppercase"
              type="button"
              @click="cleanFilters"
            >
              Limpar
            </button>
            <button
              class="flex sm:col-span-1 md:col-span-1 lg:col-span-1 justify-center items-center form-submit lg:ml-1"
              type="submit"
            >
              Pesquisar
            </button>
          </div>
        </div>
      </form>
      <div class="p-2">
        <TariffCoefficientList ref="table" :filters="filters"/>
      </div>
    </div>
    <Modal
      ref="modalCoefficient"
      content-class="sm:max-w-4xl p-4"
      :close-on-click-outside="true"
    >
      <h1 class="text-center mb-7">
        Selecione o tipo desejado para registrar um reajuste de coeficiente
        tarifário
      </h1>
      <div class="grid grid-cols-2 gap-2">
        <button
          class="non-selected-button text-center content-center h-16 uppercase shadow-md"
          @click="createTariffCoefficient('Não Patamarizada')"
        >
          Não patamarizada
        </button>
        <button
          class="non-selected-button text-center content-center h-16 uppercase shadow-md"
          @click="createTariffCoefficient('Patamarizada')"
        >
          Patamarizada
        </button>
      </div>
    </Modal>
  </div>
</template>
